<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-75">
    <!-- Contenedor del modal -->
    <div class="w-full h-full bg-white shadow-xl overflow-hidden">
      <!-- Header -->
      <div class="bg-indigo-700 py-1 px-1 sm:px-1 flex justify-between items-center">
        <h2 class="text-2xl font-bold text-white"> {{ objJaula.descripcion }}</h2>
        <button @click="close_modal"
          class="text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white">
          <span class="sr-only">Cerrar</span>
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Contenido -->
      <div class="pt-1 pb-0  ">
        
        <!-- Modalgraficounidad live -->
        <GraficoUnidadHighChart v-if="mostrarGraficoHistorial" 
        @loadGraficoLive="loadGraficoLive" 
        :esModal="true"
          :noShowSetpoint="noShowSetpoint" 
          :abreCalendario="abreCalendario"
           :objJaula="objJaula">
        </GraficoUnidadHighChart>

        <GraficoUnidadHighChartLive 
        v-if="!mostrarGraficoHistorial" 
        @loadGraficoHistorial="loadGraficoHistorial"
          :esModal="true" 
          :noShowSetpoint="noShowSetpoint" 
           :abreModalHoras="abreModalHoras"
          :objJaula="objJaula">
        </GraficoUnidadHighChartLive>

      </div>
    </div>
  </div>
</template>



<script>
import GraficoUnidadHighChartLive from "../GraficoUnidadHighChartLive";
import GraficoUnidadHighChart from "../GraficoUnidadHighChart";
export default {
  components: {
    GraficoUnidadHighChartLive,
    GraficoUnidadHighChart
  },

  create: {

  },
  props: ["objJaula", "noShowSetpoint"],
  emits: ["close"],
  data: () => ({

    visible: false,
    latitud: 0,
    longitud: 0,
    mostrarGraficoHistorial: false,
    abreCalendario: false,
    abreModalHoras: false,
  }),

  mounted() {

  },
  methods: {
    loadGraficoHistorial() {
      this.mostrarGraficoHistorial = true;
       this.$store.state.gotolive = false;
      this.abreCalendario = true;
    },
    loadGraficoLive() {
    
      this.$store.state.gotolive = true;
      this.mostrarGraficoHistorial = false;
      this.abreModalHoras = true;

    },
    close_modal() {
      //console.log('cerrar modal 1');
      this.$emit("close")
    }

  },
  watch: {

  }
}
</script>